import { MunicipalityRole } from "../types";

export const canAccessApp = (role: string): role is MunicipalityRole =>
    role === "ADMIN" || role === "ORDERER" || role === "ORDERER_ADMIN";

export const canManageOrderers = (role: MunicipalityRole): boolean =>
    role === "ADMIN" || role === "ORDERER_ADMIN";

export const canManageUnits = (role: MunicipalityRole): boolean => role === "ADMIN";

export const seesAllMunicipalityUnits = (role: MunicipalityRole): boolean =>
    role === "ADMIN";

export const canCreateCustomers = (
    role: MunicipalityRole,
    customerCreationAllowed?: boolean
): boolean => role === "ADMIN" || customerCreationAllowed === true;
